import { render, staticRenderFns } from "./Special.vue?vue&type=template&id=715a8986&"
import script from "./Special.vue?vue&type=script&lang=js&"
export * from "./Special.vue?vue&type=script&lang=js&"
import style0 from "./Special.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports